import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { MessagesService } from 'src/app/services/messages.service';
import { SharedService } from 'src/app/services/shared.service';
import { NavigationService } from 'src/app/services/navigation.service'; 

@Component({
  selector: 'app-clientes-d',
  templateUrl: './clientes-d.component.html',
  styleUrls: ['./clientes-d.component.css']
})
export class ClientesDComponent {

  cliente = {
    nombre: '',
    razon_social: '',
    rfc: '',
    direccion: '',
    cp: '',
    ciudad: '',
    estado: '',
    telefono: '',
    correo: ''
  }

  opE: any;
  token: any;
  retrievedClient: any;
  rol: any;

  // declaración de los mensajes de validación 
  showErrorMessageNombre : boolean = false;
  showErrorMessageRazon  : boolean = false;
  showErrorMessageDic    : boolean = false;
  showErrorMessageRFC    : boolean = false;
  showErrorMessageCP     : boolean = false;
  showErrorMessageCD     : boolean = false;
  showErrorMessageEst    : boolean = false;
  showErrorMessageTel    : boolean = false;
  showErrorMessageCor    : boolean = false;

  mensajeValidacionNombre : string = '';
  mensajeValidacionRazon  : string = '';
  mensajeValidacionDic    : string = '';
  mensajeValidacionRFC    : string = '';
  mensajeValidacionCP     : string = '';
  mensajeValidacionCD     : string = '';
  mensajeValidacionEst    : string = '';
  mensajeValidacionTel    : string = '';
  mensajeValidacionCor    : string = '';

  mensaje                 : string  = 'Campo requerido.';

  constructor(private router: Router,
    private navigationService: NavigationService,
    private route: ActivatedRoute,
    private requestsService: CatalogsService,
    private messagesService: MessagesService,
    private sharedService: SharedService) { }

  ngOnInit() {
    this.verificacionUsuario();
  }

  verificacionUsuario(){
    this.rol = localStorage.getItem('rol')
    this.token = String(localStorage.getItem('token1'))
    this.navigationService.disableNavigation();
    this.opE = this.route.snapshot.paramMap.get('datos');
    if (this.opE === '1') {//obtendgo creditor para actualizar
      this.retrievedClient = this.sharedService.getDataArray();
      this.cargarClient(this.retrievedClient);
    }
  }

  async cargarClient(getclient: any) {
    this.cliente.nombre = getclient.Clt_Nombre
    this.cliente.razon_social = getclient.Clt_Razon_Social
    this.cliente.rfc = getclient.Clt_RFC
    this.cliente.direccion = getclient.Clt_Direccion
    this.cliente.cp = getclient.Clt_CP
    this.cliente.ciudad = getclient.Clt_Ciudad
    this.cliente.estado = getclient.Clt_Estado
    this.cliente.telefono = getclient.Clt_Telefono
    this.cliente.correo = getclient.Clt_Correo
  }

  async validaFormulario(guardar: any, editar: any) {
    if (
      this.cliente.nombre === '' ||
      this.cliente.razon_social === '' ||
      this.cliente.rfc === '' ||
      this.cliente.direccion === '' ||
      this.cliente.cp === '' ||
      this.cliente.ciudad === '' ||
      this.cliente.estado === '' ||
      this.cliente.telefono === '' ||
      this.cliente.correo === ''
    ) {
      this.messagesService.showError('Todos los campos son obligatorios');
      return;
    }
    if (!this.isValidEmail(this.cliente.correo)) {
      this.messagesService.showError('Ingrese un correo electrónico válido');
      return;
    }
    if (this.cliente.rfc.length < 13) {
      this.messagesService.showError('El RFC debe tener al menos 13 caracteres');
      return;
    }
    if (this.cliente.cp.length < 5 ){
      this.messagesService.showError('El Codigo Postal debe tener al menos 5 caracteres');
      return;
    }
    if (guardar === true) {
      this.guardar()
    }
    if (editar === true) {
      this.editar()
    }
  }

  editar() {
    this.requestsService.editClient(this.cliente, this.retrievedClient.Id_Cliente, this.token).subscribe(
      (res) => {
        this.messagesService.showMessage(res.message);
        this.router.navigate(['/clientes']);
      },
      (err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  guardar() {
    this.requestsService.createClient(this.cliente, this.token).subscribe(
      (res) => {
        this.messagesService.showMessage(res.message);
        this.router.navigate(['/clientes']);
      },
      (err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  eliminar() {
    this.requestsService.deleteClient(this.retrievedClient.Id_Cliente, this.token).subscribe(
      (res) => {
        this.messagesService.showMessage(res.message);
        this.router.navigate(['/clientes']);
      },
      (err) => {
        this.messagesService.showError(err.error.error[0].message);
      }
    )
  }

  cancelar() {
    this.router.navigate(['/clientes']);
  }

  private isNumber(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  private isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  // mensajes de validación 
  mostrarMensaje(campo: any, tipo: string) {
    switch(tipo){
      case 'nombre':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageNombre = true;
          this.mensajeValidacionNombre = this.mensaje;
        } else {
          this.showErrorMessageNombre = false;
        }
      break;
      case 'razonSocial':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageRazon = true;
          this.mensajeValidacionRazon = this.mensaje;
        } else {
          this.showErrorMessageRazon = false;
        }
      break;
      case 'rfc':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageRFC = true;
          this.mensajeValidacionRFC = this.mensaje;
        } else {
          this.showErrorMessageRFC = false;
        }
      break;
      case 'direccion':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageDic = true;
          this.mensajeValidacionDic = this.mensaje;
        } else {
          this.showErrorMessageDic = false;
        }
      break;
      case 'cp':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageCP = true;
          this.mensajeValidacionCP = this.mensaje;
        } else {
          this.showErrorMessageCP = false;
        }
        break;
      case 'ciudad':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageCD = true;
          this.mensajeValidacionCD = this.mensaje;
        } else {
          this.showErrorMessageCD = false;
        }
        break;
      case 'estado':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageEst = true;
          this.mensajeValidacionEst = this.mensaje;
        } else {
          this.showErrorMessageEst = false;
        }
        break;
      case 'telfono':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageTel = true;
          this.mensajeValidacionTel = this.mensaje;
        } else {
          this.showErrorMessageTel = false;
        }
        break;
      case 'correo':
        if (campo.invalid && (campo.dirty || campo.touched)) {
          this.showErrorMessageCor = true;
          this.mensajeValidacionCor = this.mensaje;
        } else {
          this.showErrorMessageCor = false;
        }
      break;
    }
  }

}
